import React, { createContext, useState } from "react";

export const OrderContext = createContext();
export const OrderProvider = ({ children }) => {
    const [storeId, setStoreId] = useState(0);
    return <OrderContext.Provider value={{ storeId, setStoreId }}>
        {children}
    </OrderContext.Provider>
};